












import { Component, Prop, Vue } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import CloseIcon from '@/components/icons/Close.vue';
import SuccessFeedback from '@/components/icons/SuccessFeedback.vue';

@Component({
  components: {
    FilledButton,
    SuccessFeedback,
    CloseIcon
  }
})
export default class SuccessModal extends Vue {
  @Prop() onConfirm?: Function;
  @Prop() title!: string;
  @Prop() btnText!: string;

  onClose() {
    eventBus.$emit('closeModal');
  }

  onSuccessClick() {
    this.onClose();
    if (this.onConfirm) {
      this.onConfirm();
    }
  }
}
